import { STEPS } from '../../utils/routes.util';

export default BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state(STEPS.SUIVIE_AUTHENT, {
    url: '/suivie-authent',
    template: '<dmattnt-suivie-authent></dmattnt-suivie-authent>',
    data: {label: 'Suivi'}
  }).state(STEPS.SUIVIE_RESULTAT, {
    url: '/suivie-resultat',
    template: '<dmattnt-suivie-resultat></dmattnt-suivie-resultat>',
    data: {label: 'Resultat'}
  });
}



// WEBPACK FOOTER //
// ./src/modules/suivie-dossier/routes.js